<template>
  <div v-if="!isShowPrint" class="your-betslip">
    <div class="your-betslip__header">
      <div class="your-betslip__header__title">
        YOUR BETSLIP
      </div>
      <div class="your-betslip__header__clear">
        <button
            data-sn-right=".your-betslip__header__close"
            data-sn-up=".your-betslip__header__close"
            data-sn-left=".your-betslip__header__close"
            class="focusable your-betslip__header__clear__btn"
            @click="$emit('removeAllBetslip')"
            @keyup.enter="$emit('removeAllBetslip')"
        >CLEAR BETSLIP</button>
        <button
            @click="$parent.$emit('close')"
            @keyup.enter="$parent.$emit('close')"
            data-sn-right=".your-betslip__header__clear__btn"
            data-sn-up=".your-betslip__header__clear__btn"
            data-sn-left=".your-betslip__header__clear__btn"
            class="your-betslip__header__close focusable"
        >
          <img src="@/assets/images/ticket/remove.png" />
        </button>
      </div>
    </div>
    <div class="your-betslip__content">
      <div class="your-betslip__content__stake">
        <div class="your-betslip__content__stake__label">
          Common Stake:
        </div>
        <div class="your-betslip__content__stake__input input-icon">
          <input
              ref="refCommonStake"
              v-model.number="commonStakeNumber"
              @keypress="onlyNumber"
              @keydown.enter.prevent="focusOutCommonStake"
              @keydown.tab.prevent="focusOutCommonStake('tab')"
              data-sn-up=".your-betslip__header__clear__btn"
              data-sn-down=".your-betslip__item__top__close__item0"
              data-sn-right=".your-betslip__item__top__close__item0"
              data-sn-left=".your-betslip__item__top__close__item0"
              class="form-control common-stake focusable"
              type="tel"
          />
          <i>{{ currencySymbol }}</i>
        </div>
      </div>
      <div v-if="dataBetslip.length > 0" class="your-betslip__items">
        <div
            v-for="(item, index) in dataBetslip"
            :key="index"
            class="your-betslip__item"
            :class="{errorBet: item.isErrorBet || item.isBetExpired}"
        >
          <div class="your-betslip__item__top">
            <div class="your-betslip__item__top__title">{{ item.name }} {{ this.$filters.formatDate(item.draw_date) }}</div>
            <button
                :ref="`refRemoveItem${index}`"
                :data-sn-down="`.input-stake-item${index}`"
                :data-sn-right="`.input-stake-item${index}`"
                :data-sn-left="`.input-stake-item${index}`"
                class="your-betslip__item__top__close focusable"
                :class="`your-betslip__item__top__close__item${index}`"
                @keyup.enter="$emit('removeItemBetslip', index)"
            >
              <img
                  @click="$emit('removeItemBetslip', index)"
                  src="@/assets/images/ticket/remove.png" />
            </button>
          </div>
          <div class="your-betslip__item__numbers">
            <div class="your-betslip__item__numbers__label">
              Chosen:
            </div>
            <div v-if="item.numbers[0] && item.numbers[0].length > 0 || item.numbers[1] && item.numbers[1].length > 0" class="your-betslip__item__numbers__content">
              <a
                  v-for="(number, i) in item.numbers[0]"
                  :key="i"
              >{{ number }}</a>
              <a
                  v-for="(number, i) in item.numbers[1]"
                  :key="i"
                  class="bonus"
              >{{ number }}</a>
            </div>
            <div v-if="item.numbers.length === 0" class="your-betslip__item__numbers__content">
              <b>{{ item.text }} </b>
            </div>
          </div>
          <div class="your-betslip__item__items">
            <div class="your-betslip__item__items__stake item-betslip-common">
              <div class="your-betslip__item__items__stake__label item-label-common">
                Stake
              </div>
              <div class="your-betslip__item__items__stake__input input-icon">
                <input
                    :ref="`refInputItem${index}`"
                    :data-sn-right="`.your-betslip__item__top__close__item${index}`"
                    :data-sn-left="`.your-betslip__item__top__close__item${index}`"
                    v-model.number="item.stake"
                    @keypress="onlyNumber"
                    @keyup="onChangeStake(index, $event)"
                    @blur="focusOut"
                    class="form-control focusable"
                    :class="[{errorStake: item.error || item.errorMin || item.errorPayoutMax}, `input-stake-item${index}`]"
                    type="tel"
                />
                <i>{{ currencySymbol }} </i>
              </div>
              <div v-if="item.error">
                Max stake: {{ $filters.formatThousandNumber(Number(item.maxStake)) }}
              </div>
              <div v-if="item.errorMin">
                Min stake: {{ $filters.formatThousandNumber(Number(item.betMin)) }}
              </div>
              <div v-if="item.errorPayoutMax">
                Max Payout: {{ $filters.formatThousandNumber(Number(item.payout_max)) }}
              </div>
            </div>
            <div class="your-betslip__item__items__bet-type item-betslip-common">
              <div class="your-betslip__item__items__bet-type__label item-label-common">
                Bet Type
              </div>
              <div v-if="item.numbers[0] && item.numbers[0].length > 0 || item.numbers[1] && item.numbers[1].length > 0" class="your-betslip__item__items__bet-type__content item-value-common">
                {{ item.numbers[0].length +  item.numbers[1].length}} Numbers
              </div>
              <div v-else class="your-betslip__item__items__bet-type__content item-value-common">
                {{  item.summary }}
              </div>
            </div>
            <div class="your-betslip__item__items__max-stake item-betslip-common">
              <div class="your-betslip__item__items__max-stake__label item-label-common">
                Max Stake
              </div>
              <div class="your-betslip__item__items__max-stake__content item-value-common">
                {{ currencySymbol }}{{ $filters.formatThousandNumber(Number(item.maxStake)) }}
              </div>
            </div>
            <div class="your-betslip__item__items__odds item-betslip-common">
              <div class="your-betslip__item__items__odds__label item-label-common">
                Odds
              </div>
              <div class="your-betslip__item__items__odds__content">
                {{ $filters.formatThousandNumber(Number(item.odds)) }}
              </div>
            </div>
            <div class="your-betslip__item__items__to-win item-betslip-common">
              <div class="your-betslip__item__items__to-win__label item-label-common">
                To Win
              </div>
              <div class="your-betslip__item__items__max-stake__content item-value-common">
                {{ currencySymbol }}{{ $filters.formatThousandNumber(item.toWin) }}
              </div>
            </div>
          </div>
        </div>
        <div class="your-betslip__total-stake">
          <div class="your-betslip__total-stake__label">
            Your Total Stake: {{ currencySymbol }}{{ $filters.formatNumber(totalStake) }}
          </div>
          <div class="your-betslip__total-stake__input input-icon">
            <input
                ref="refTotalStake"
                v-model.number="totalStakeNumber"
                @keypress="onlyNumber"
                @keyup="onChangeTotalStake"
                @keydown.enter.prevent="focusOutTotalStake"
                :data-sn-up="`.input-stake-item${dataBetslip.length-1}`"
                data-sn-right=".your-betslip__buttons__continue"
                :data-sn-left="`.input-stake-item${dataBetslip.length-1}`"
                data-sn-down=".your-betslip__buttons__continue"
                class="form-control focusable"
                type="tel"
            />
            <i>{{ currencySymbol }}</i>
          </div>
        </div>
      </div>
      <div v-if="dataBetslip.length === 0" class="your-betslip__no-data">
        No data, please continue betting!
      </div>
    </div>
    <div v-if="isShowErrorExpired" class="your-betslip__warning-expired">
      <div class="your-betslip__warning-expired__text">Some bets in your betslip have expired! Please remove them or move them to next draw date.</div>
      <div class="your-betslip__warning-expired__buttons">
        <button @click="$emit('removeDrawsExpired')" class="btn-remove focusable">Remove</button>
        <button @click="$emit('moveToNextDraw')" class="btn-move focusable">Move to next draw</button>
      </div>
    </div>
    <div v-if="isShowResBookABet" class="your-betslip__boot-a-bet">
      <div class="your-betslip__boot-a-bet__title">
        Your booking code has been generated
      </div>
      <div class="your-betslip__boot-a-bet__code">
        <span>Booking Code:</span> {{ bookingCodeBootABet }}
      </div>
      <div class="your-betslip__boot-a-bet__scan-code">
        <vue-barcode
            :value="bookingCodeBootABet"
            :options="{ displayValue: false }"
        />
      </div>
      <div class="your-betslip__boot-a-bet__print">
        <button @click="handlePrintBookABet">Print</button>
      </div>
    </div>
    <div class="your-betslip__buttons">
      <button
          ref="refButtonContinue"
          @click="$parent.$emit('close')"
          data-sn-up=".your-betslip__header__close"
          type="button"
          class="btn btn-primary your-betslip__buttons__continue button-betslip-common focusable"
      >
        CONTINUE BETTING
      </button>
      <button
          v-if="this.$store.state.token === '' || this.$store.state.token === undefined"
          type="button"
          data-sn-up=".your-betslip__header__close"
          data-sn-right=".your-betslip__buttons__login"
          :class="{
            disableButton: isDisableProcessBet || dataBetslip.length === 0,
           'your-betslip__buttons__loading': loadingBootABet
          }"
          @click="$parent.$emit('book-a-bet')"
          class="btn btn-primary your-betslip__buttons__continue button-betslip-common focusable"
      >
        <span class="your-betslip__buttons__loading__loader"></span>
        BOOK A BET
      </button>
      <button
          v-if="this.$store.state.token !== ''"
          type="button"
          data-sn-up=".your-betslip__header__close"
          data-sn-right=".your-betslip__buttons__process-bet"
          :class="{
            disableButton: isDisableProcessBet || dataBetslip.length === 0,
           'your-betslip__buttons__loading': loadingBootABet
          }"
          @click="$parent.$emit('book-a-bet')"
          class="btn btn-primary your-betslip__buttons__continue your-betslip__buttons__book-a-bet button-betslip-common focusable"
      >
        <span class="your-betslip__buttons__loading__loader"></span>
        BOOK A BET
      </button>
      <button
          type="button"
          data-sn-up=".your-betslip__header__close"
          v-if="this.$store.state.token === '' || this.$store.state.token === undefined"
          @click="$parent.$emit('login')"
          class="btn btn-primary your-betslip__buttons__continue your-betslip__buttons__login button-betslip-common focusable"
      >
        LOGIN
      </button>
      <button
          data-sn-up=".your-betslip__header__close"
          data-sn-left=".your-betslip__buttons__book-a-bet"
          v-if="$store.state.token"
          :disabled="isDisableProcessBet || dataBetslip.length === 0"
          @click="$parent.$emit('process-bet')"
          :class="{
            disableButton: isDisableProcessBet || dataBetslip.length === 0,
           'your-betslip__buttons__loading': loading
          }"
          class="your-betslip__buttons__process-bet button-betslip-process button-betslip-common focusable"
      >
        <span class="your-betslip__buttons__loading__loader"></span>
        PROCESS BET
      </button>
<!--      <button-->
<!--          v-if="this.loading"-->
<!--          class="disableButton your-betslip__buttons__process-bet button-betslip-process button-betslip-common"-->
<!--      >-->
<!--      </button>-->
    </div>
  </div>
  <div v-else>
    <div class="your-betslip__header">
      <div class="your-betslip__header__title">
        YOUR BETSLIP
      </div>
      <div class="your-betslip__header__clear">
        <button
            @click="$parent.$emit('close')"
            data-sn-right=".your-betslip__header__clear__btn"
            data-sn-up=".your-betslip__header__clear__btn"
            data-sn-left=".your-betslip__header__clear__btn"
            class="your-betslip__header__close focusable"
        >
          <img src="@/assets/images/ticket/remove.png" />
        </button>
      </div>
    </div>
    <div class="your-betslip__content__print">
      <div class="your-betslip__content__print__title">
        Your bet was successful, your results will be available after the draw
      </div>
      <div class="your-betslip__content__print__button">
        <button
            @click="$emit('print')"
            type="button"
            class="btn btn-success"
        >PRINT</button>
      </div>
    </div>
  </div>
</template>
<script>
import jsPDF from 'jspdf'
import html2canvas from "html2canvas"
// import moment from "moment";
import VueBarcode from '@chenfengyuan/vue-barcode';

export default {
  props: {
    isShowPrint: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingBootABet: {
      type: Boolean,
      default: false
    },
    dataBetslip: {
      type: Array,
      default: () => []
    },
    commonStake: {
      type: Number,
      default: 0
    },
    totalStake: {
      type: Number,
      default: 0
    },
    isDisableProcessBet: {
      type: Boolean,
      default: false
    },
    isShowErrorExpired: {
      type: Boolean,
      default: false
    },
    isShowResBookABet: {
      type: Boolean,
      default: false
    },
    bookingCodeBootABet: {
      type: String,
      default: ''
    },
  },
  components: {
    VueBarcode
  },
  data () {
    return {
      commonStakeNumber: this.$filters.formatNumber(this.commonStake),
      totalStakeNumber: this.$filters.formatNumber(this.totalStake),
      currencySymbol: process.env.VUE_APP_CURRENCY_SYMBOL,
      isPrintData: false,
    }
  },
  computed: {
    listBetslips() {
      return this.dataBetslip;
    },
    settings() {
      return this.$store.getters.getSettings
    },
  },
  mounted() {
    this.$refs.refCommonStake.focus();
    const parameters = this.$route.query;
    if(parameters.currency_symbol) {
      this.currencySymbol = parameters.currency_symbol;
    }
  },
  created() {
    this.$store.dispatch('apiGetSettings');
  },
  watch: {
    settings(val) {
      if (val) {
        if (val.currency_symbol && val.currency_symbol.length > 0) {
          this.currencySymbol = val.currency_symbol;
        } else {
          const parameters = this.$route.query;
          if(parameters.currency_symbol) {
            this.currencySymbol = parameters.currency_symbol;
          }
        }
      }
    },
    totalStake(val) {
      this.totalStakeNumber = this.$filters.formatNumber(val);
    },
    dataBetslip(val) {
      if(val) {
        this.$refs.refCommonStake.focus();
      }
    },
  },
  methods: {
    async handlePrintBookABet() {
      await this.$emit('addClassModalClass', true);
      this.isPrintData = true;
      const doc = new jsPDF({
        orientation: 'landscape',
      });
      const value = await this.$refs.content;
      html2canvas(value).then(function (canvas) {
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        const widthRatio = pageWidth / canvas.width;
        const heightRatio = pageHeight / canvas.height;
        const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;

        const canvasWidth = canvas.width * ratio;
        const canvasHeight = canvas.height * ratio;

        const marginX = (pageWidth - canvasWidth) / 2;
        const marginY = (pageHeight - canvasHeight) / 2;

        doc.addImage(canvas.toDataURL('image/jpeg', 1.0), 'JPEG', marginX, marginY, canvasWidth, canvasHeight);
        // const today = moment().format('DD/MM/YYYY/hh/mm/ss');
        doc.autoPrint();
        const string = doc.output('datauristring')
        const embed = "<embed width='100%' height='100%' src='" + string + "'/>"
        const x = window.open();
        x.document.open();
        x.document.write(embed);
        x.document.close();
        // x.print();
        // x.focus();
        // x.close();
        // doc.save(`your-betslip_${today}.pdf`, {returnPromise:true}).then(alert('PDF render all done!'));
      });
      this.isPrintData = false;
      this.$emit('addClassModalClass', false);
    },
    onChangeCommonStake($event) {
      const value = $event.target.value;
      if(typeof value === 'string')  {
        this.commonStakeNumber = Number(value.replace(/,/g, ""))
      } else {
        if(value > 0) {
          this.commonStakeNumber = Number(value)
        } else {
          this.commonStakeNumber = 0
        }
      }
    },
    onChangeTotalStake($event) {
      const value = $event.target.value;
      if(typeof value === 'string')  {
        this.totalStakeNumber = Number(value.replace(/,/g, ""))
      } else {
        if(value > 0) {
          this.totalStakeNumber = Number(value)
        } else {
          this.totalStakeNumber = 0
        }
      }
    },
    focusOutCommonStake(type) {
      const val = this.commonStakeNumber;
      if(val > 0) {
        if(typeof val === 'string')  {
          const number = Number(val.replace(/,/g, ""))
          this.$emit('changeStake', {val: number, type: 'common'})
        } else {
          const number = Number(val)
          if(val > 0) {
            this.$emit('changeStake', {val: number, type: 'common'})
          } else {
            this.$emit('changeStake', {val: 0, type: 'common'})
          }
        }
        if(val >= 0){
          this.commonStakeNumber = this.$filters.formatNumber(Number(val))
        } else {
          const stakeNumber = Number(val.replace(/,/g, ""))
          this.commonStakeNumber = this.$filters.formatNumber(stakeNumber)
        }
      }
      if(type==='tab') {
        this.$refs.refRemoveItem0[0]?.focus();
      }
    },
    onChangeStake(index, $event) {
      this.listBetslips.forEach((item, key) => {
        if(index === key) {
          let value = $event.target.value;
          if(typeof value === 'string')  {
            item.stake = Number(value.replace(/,/g, ""))
            item.toWin = item.stake * Number(item.odds);
          } else {
            if(value > 0) {
              item.stake = Number(value)
              item.toWin = item.stake * Number(item.odds);
            } else {
              item.stake = 1
              item.toWin = item.stake * Number(item.odds);
            }
          }
        }
      })
    },
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },
    focusOutTotalStake() {
      const val = this.totalStakeNumber;
      if(typeof val === 'string')  {
        const number = Number(val.replace(/,/g, ""))
        this.$emit('changeStake', {val: number, type: 'total'})
      } else {
        const number = Number(val)
        if(val > 0) {
          this.$emit('changeStake', {val: number, type: 'total'})
        } else {
          this.$emit('changeStake', {val: 0, type: 'total'})
        }
      }
    },
    focusOut() {
      let totalStake = 0;
      this.listBetslips.forEach(item => {
        totalStake = totalStake + Number(item.stake);
      })
      this.$emit('changeStake', {val: this.listBetslips, type: 'list', totalStake})
    },
  }
}
</script>
<style scoped lang="scss" src="@/assets/scss/ticket/yourBetslip.scss"/>
